import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';

import App from './components/App';
import './index.css';

import registerServiceWorker from './registerServiceWorker';

const render = Component => {
	ReactDOM.render(
		<Router>
			<div><Component /></div>
		</Router>,
		document.getElementById('root')
	)
}

render(App);

if (module.hot) {
	module.hot.accept('./components/App', () => {
		render(require('./components/App').default);
	})
}

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js